import { render, staticRenderFns } from "./colorfulIcon.vue?vue&type=template&id=3abd26a1&scoped=true&"
import script from "./colorfulIcon.vue?vue&type=script&lang=js&"
export * from "./colorfulIcon.vue?vue&type=script&lang=js&"
import style0 from "./colorfulIcon.vue?vue&type=style&index=0&id=3abd26a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abd26a1",
  null
  
)

export default component.exports